import React from 'react';

const Quests = () => {
  return (
    <div className="page-content">
      <h2>Quests</h2>
      <p>Content for quests goes here.</p>
    </div>
  );
};

export default Quests;
